(function () {
  let lastAddTs = 0;

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    // intercettiamo SOLO cart/add.js
    if (url.includes('/cart/add')) {
      const now = Date.now();

      // se arriva un secondo add entro 1000ms → BLOCCO
      if (now - lastAddTs < 1000) {
        console.warn('[quantity-guard] doppio add-to-cart bloccato');
        return Promise.reject(new Error('Duplicate add-to-cart blocked'));
      }

      lastAddTs = now;
    }

    return originalFetch.apply(this, args);
  };
})();
